"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const fontFamilies = {
  "body": "Sofia Pro"
};
exports.default = fontFamilies;